/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import profileTemplate from './profile.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ProfileRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.profile', {
            url: '/profile',
            module: 'private',
            auth: types.allAuthorities,
            views: {
                "content@home": {
                    templateUrl: profileTemplate,
                    controllerAs: 'vm',
                    controller: 'ProfileController'
                }
            },
            data: {
                pageTitle: 'profile.profile'
            },
            ncyBreadcrumb: {
                label: '{"icon": "account_circle", "label": "profile.profile"}'
            }
        });

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.routes.js